import { useTranslation } from "react-i18next";

import { ISoundLevelConditions } from "interfaces/rules.interface";

import { InfoField } from "./InfoField";

type LogPresetSoundLevelProps = {
  preset: ISoundLevelConditions;
};

export function LogPresetSoundLevel({ preset }: LogPresetSoundLevelProps) {
  const { t } = useTranslation();

  return (
    <>
      <InfoField
        label={t("minimum_time_presence_is")}
        value={(preset.initial_presence_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
      <InfoField
        label={t("sound_level_is_greater_than_or_equal_to")}
        value={preset.sound_level_gte ?? 0}
        unit={t("dBA")}
      />
    </>
  );
}
